<template>
  <!--begin::Container-->
  <div class="wrapper">
    <div class="section-shaped my-0 skew-separator skew-mini ">
      <v-img
        class="page-header header-filter  header-small "
        max-height="250px"
        lazy-src="/media/biz-header.jpg"
        src="/media/test-biz-header.png"
        gradient="to top right, rgba(0,0,0,.53), rgba(25,32,72,.7)"
      >
        <div class="container " style="padding-bottom: 65px;">
          <div class="md-layout justify-md-center ">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mt-35 text-center"
            >
              <div class="lato-header  font-weight-bolder text-white"></div>
              <div class="mt-5">
                <h4 class="text-white "></h4>
              </div>
            </div>
          </div>
        </div>
      </v-img>
    </div>

    <div class="main main-raised" style="background:#fff;">
      <div class="container">
        <div class="text-lg-right">
          <v-btn
            v-if="orders.length > 0"
            elevation="9"
            rounded
            color="grey"
            @click="$router.go(-1)"
          >
            <v-icon left>
              mdi-arrow-left
            </v-icon>
            Back
          </v-btn>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="container">
            <h3>
              {{ orders[0].supplier_name }}
            </h3>
            <div class="row ">
              <div class="col-lg-4">
                <v-card class="card card-custom card-stretch">
                  <div class="card-header">
                    <div class="card-title">
                      <h3 class="card-label">Billing Info</h3>
                    </div>
                  </div>
                  <div class="card-body">
                    <!-- <h5 class="font-family-primary font-weight-semibold">Great Local Dealer</h5> -->

                    <p class="mb-2">
                      {{ billto.company_name }}<br />
                      {{ billto.address_line1 }}<br />
                      {{ billto.address_line2 }}<br />
                      {{ billto.city }} {{ billto.state }} {{ billto.zip_code }}
                    </p>
                    <p class="mb-2">
                      <span class="font-weight-semibold mr-2">Phone:</span>
                      (123) 456-7890
                    </p>
                  </div>
                </v-card>
              </div>
              <!-- end col -->
              <div class="col-lg-4">
                <v-card class="card card-custom card-stretch">
                  <div class="card-header">
                    <div class="card-title">
                      <h3 class="card-label">Shipping Info</h3>
                    </div>
                  </div>
                  <div class="card-body">
                    <!-- <h5 class="font-family-primary font-weight-semibold">Great Local Dealer Recieving</h5> -->

                    <p class="mb-2">
                      {{ shipto.company_name }}<br />
                      {{ shipto.address_line1 }}<br />
                      {{ shipto.address_line2 }}<br />
                      {{ shipto.city }} {{ shipto.state }} {{ shipto.zip_code }}
                    </p>
                    <p class="mb-2">
                      <span class="font-weight-semibold mr-2">Phone:</span>
                      (123) 456-7890
                    </p>
                  </div>
                </v-card>
              </div>
              <!-- end col -->

              <div class="col-lg-4">
                <v-card flat>
                  <ul class="list-unstyled mb-0">
                    <li>
                      <p v-if="orders.length > 0" class="mb-2">
                        <span class="font-weight-semibold mr-2"
                          >Purchase Order #:</span
                        >
                        {{ orders[0].po_number }}
                      </p>
                      <p class="mb-2">
                        <span class="font-weight-semibold mr-2"
                          >Payment Type:</span
                        >
                        NET TERMS
                      </p>
                    </li>
                  </ul>
                </v-card>
              </div>
              <!-- end col -->
            </div>

            <div class="row  ">
              <div class="col-lg-12">
                <v-card class="card card-custom card-stretch">
                  <div class="card-header card-header-tabs-line">
                    <div class="card-title">
                      <h3 class="card-label">Order Return</h3>
                    </div>
                    <div class="card-toolbar"></div>
                  </div>

                  <div class="card-body">
                    <!--begin: Datatable-->
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="text-left">Line ID</th>
                          <th style="width:180px;">SKU</th>
                          <th>Thumb</th>
                          <th>Item</th>
                          <th>Qty</th>
                          <th class="text-left">Price</th>
                          <th class="text-left">Subtotal</th>
                          <th class="text-left">Qty to Return</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, idx) in orders" :key="idx">
                          <td>{{ idx + 1 }}</td>
                          <td>{{ item.sku_id }}</td>
                          <td>
                            <v-img
                              class="d-flex align-self-center mr-3 rounded-circle"
                              :src="
                                item.url != null
                                  ? baseurl + item.url
                                  : '/media/rollerskate.png'
                              "
                              alt="Generic placeholder image"
                              width="50"
                              height="50"
                            >
                            </v-img>
                          </td>
                          <td>
                            {{ item.product_name }}
                            <span v-if="item.item_name != 'default'"
                              >({{ item.item_name }})</span
                            >
                          </td>
                          <td>
                            <span>Ordered: {{ item.qty }}</span
                            ><br />
                            <span>Returned: {{ item.qty_returned }}</span>
                          </td>
                          <td>{{ item.price | dollar_format }}</td>
                          <td>{{ (item.price * item.qty) | dollar_format }}</td>
                          <td>
                            <v-text-field
                              v-model="item.qty_to_return"
                              type="number"
                              label="qty to return"
                              dense
                              outlined
                              style="width: 100px"
                            ></v-text-field>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <!--end: Datatable-->
                    <div class="row" style="margin-top: 30px;">
                      <div class="col-lg-6" style="text-align: center;">
                        Order Return Policy<br />
                        {{ order_return_policy }}
                      </div>
                      <div class="col-lg-3">
                        <v-textarea
                          v-model="return_note"
                          outlined
                          label="Return Note"
                        ></v-textarea>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                          v-model="return_reason"
                          label="Return Reason"
                          :items="reason_list"
                        ></v-select>
                      </div>
                    </div>
                    <div class="text-lg-right">
                      <v-btn @click="updateReturn"> Request </v-btn>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  filters: {
    date_format: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    },
    dollar_format: function(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },
  },
  data: () => ({
    order_return_policy: "",
    return_note: "",
    return_reason: "Not needed",
    reason_list: ["Not needed", "Defective", "Error in ordering", "Mis-ship"],
    baseurl: process.env.VUE_APP_STRAPI_API_URL || "http://localhost:1337",
    dialog: false,
    orderTab: "Information",
    selected: 2,
    model: "tab-2",
    orders: [],
    main_order_date: "",
    billto: [],
    shipto: [],
  }),
  apollo: {
    // vendor_order_detail: {
    //   client: "ecomClient",
    //   query: gql`
    //     query OrderDetail($vendor_order_id: Int) {
    //       vendor_order_detail(vendor_order_id: $vendor_order_id) {
    //         id
    //         supplier
    //         price
    //         qty
    //         qty_invoiced
    //         qty_shipped
    //         qty_returned
    //         item_id
    //         product_id
    //         product_name
    //         item_name
    //         sku_id
    //         supplier_name
    //         url
    //         order_id
    //         status
    //         subtotal
    //         shipping_amount
    //         grand_total
    //         created_at
    //         main_order_id
    //         po_number
    //       }
    //     }
    //   `,
    //   variables() {
    //     return {
    //       vendor_order_id: parseInt(this.$route.params.id),
    //     };
    //   },
    // },
  },

  created() {
    this.getVendorOrderDetail();
  },
  methods: {
    ...mapActions(["getCompanyInfo"]),
    isInt(n) {
      return n % 1 === 0;
    },
    async updateReturn() {
      let flag = 0,
        item_arr = [],
        isZero = 1;
      for (let i in this.orders) {
        if (!this.isInt(parseFloat(this.orders[i].qty_to_return))) {
          flag = 1;
        }
        if (
          parseInt(this.orders[i].qty_to_return) >
          parseInt(this.orders[i].qty) - parseInt(this.orders[i].qty_returned)
        ) {
          flag = 1;
        }
        if (parseInt(this.orders[i].qty_to_return) != 0) {
          isZero = 0;
        }
        item_arr.push(this.orders[i].id + "-" + this.orders[i].qty_to_return);
      }
      if (flag == 1) {
        Swal.fire({
          title: "",
          text: "Invalid qty",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      } else if (isZero == 1) {
        Swal.fire({
          title: "",
          text: "Empty",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      } else {
        // let res = await this.$apollo.mutate({
        //   client: "ecomClient",
        //   mutation: gql`
        //     mutation AddReturnMutation(
        //       $order_id: Int!
        //       $item_str: String!
        //       $return_note: String!
        //       $return_reason: String!
        //     ) {
        //       addReturn(
        //         order_id: $order_id
        //         item_str: $item_str
        //         return_note: $return_note
        //         return_reason: $return_reason
        //       )
        //     }
        //   `,
        //   variables: {
        //     order_id: parseInt(this.$route.params.id),
        //     item_str: item_arr.join("_"),
        //     return_note: this.return_note,
        //     return_reason: this.return_reason,
        //   },
        // });
        // if (res.data.addReturn == true) {
        //   Swal.fire({
        //     title: "",
        //     text: "Updated successfully.",
        //     icon: "success",
        //     confirmButtonClass: "btn btn-secondary",
        //   });
        //   this.$router.push(
        //     "/store/order-detail/" + this.orders[0].main_order_id
        //   );
        // }
      }
    },
    async getVendorOrderDetail() {
      await this.$apollo.queries.vendor_order_detail.refetch();
      let order_detail = this.vendor_order_detail;
      if (order_detail.length > 0) {
        this.main_order_date = order_detail[0].created_at;
        if (order_detail[0].supplier != undefined) {
          let cres = await this.getCompanyInfo({
            id: order_detail[0].supplier,
          });
          if (cres.data.order_return_policy != undefined) {
            this.order_return_policy = cres.data.order_return_policy;
          }
        }
        //get order address
        // let ares = await this.$apollo.query({
        //   client: "ecomClient",
        //   query: gql`
        //     query OrderAddress($main_order_id: Int) {
        //       order_address: order_address(main_order_id: $main_order_id) {
        //         id
        //         main_order_id
        //         address_line1
        //         address_line2
        //         city
        //         state
        //         zip_code
        //         address_type
        //         company_name
        //         first_name
        //         last_name
        //       }
        //     }
        //   `,
        //   variables: {
        //     main_order_id: parseInt(order_detail[0].main_order_id),
        //   },
        // });
        // let address_arr = ares.data.order_address;
        // for (let i in address_arr) {
        //   if (address_arr[i].address_type == "billto") {
        //     this.billto = address_arr[i];
        //   } else {
        //     this.shipto = address_arr[i];
        //   }
        // }
      }
      for (let i in order_detail) {
        order_detail[i]["qty_to_return"] =
          parseInt(order_detail[i].qty) -
          parseInt(order_detail[i].qty_returned);
      }
      this.orders = order_detail;
    },
  },
};
</script>
